import { render, staticRenderFns } from "./Unduh.vue?vue&type=template&id=e14cc0fc"
import script from "./Unduh.vue?vue&type=script&lang=js"
export * from "./Unduh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports